import { makeAutoObservable } from 'mobx'
import { ArticleList } from '../constants'
import RootStore from './root'
import { PagingSubStore, SingleSubStore } from './subStore'

import type { components, operations } from '../constants/schema'

export class ArtfairStore {
  rootStore: RootStore

  /* 아트뮤지엄 */
  artMuseumPagingStore = new PagingSubStore<components['schemas']['ArticleDto']>('/article') // 목록 조회
  artMuseumDetailStore = new SingleSubStore<ArticleList>( // 상세 조회
    (param?: Record<string, any>) => `/article/${param?.articleId}`,
  )
  articleCategoryPagingStore = new PagingSubStore<components['schemas']['ArticleCategoryDto']>('/article/category')

  /* 이벤트*/
  eventPagingStore = new PagingSubStore<components['schemas']['EventDto']>('/event') // 목록 조회
  eventDetailStore = new SingleSubStore<components['schemas']['EventDto']>( // 상세 조회
    (param?: operations['EventController_findEventCurrent']['parameters']['path']) => `/event/${param?.id}`,
  )

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }
}
